module.exports = __webpack_public_path__ + "img/COV16.4fd1f82e.png";